const WHATSAPP_NUMBER = '96170902631';

function getPrice(item) {
  const price = parseFloat(item.item_price ?? item.sell_price ?? 0);
  return Number.isNaN(price) ? 0 : price;
}

// items: single product or array of {item_id, item_name, quantity, item_price/sell_price}
export function buildWhatsAppOrderMessage(items) {
  const list = Array.isArray(items) ? items : [items];
  let total = 0;

  const lines = list.map((item) => {
    const qty = item.quantity && item.quantity > 1 ? item.quantity : 1;
    const price = getPrice(item);
    const subtotal = price * qty;
    total += subtotal;

    const qtyPricePart = qty > 1
      ? ` x${qty} - $${price.toFixed(2)} each = $${subtotal.toFixed(2)}`
      : ` - $${price.toFixed(2)}`;

    return `- ${item.item_name} (ID: ${item.item_id})${qtyPricePart}`;
  });

  return `Hi, I'd like to order:\n${lines.join('\n')}\n\nTotal: $${total.toFixed(2)}`;
}

export function openWhatsAppOrder(items) {
  const message = buildWhatsAppOrderMessage(items);
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}
